import React from 'react'
import { Link } from 'react-router-dom'
import Shop_1 from '../../../assets/images/background/shop-page-bg.jpg'
import Shop_2 from '../../../assets/images/about/arrow-brudcrumb.svg'

const PageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${Shop_1})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>Shop</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews.
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={Shop_2} alt="icon" />
                        </li>
                        <li>
                            <span>Shop</span>
                        </li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default PageInear
